import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router';
import HomePage from './pages/HomePage.vue';
import MyShopsPage from './pages/MyShopsPage.vue';
import ShopApplicationPage from './pages/ShopApplicationPage.vue';

export default createRouter({
  history: typeof window === 'undefined' ? createMemoryHistory() : createWebHistory(),
  routes: [
    { path: '/', component: HomePage, meta: { title: '怡呵美门店申报' } },
    { path: '/shops', component: MyShopsPage, meta: { title: '我的门店' } },
    { path: '/shops/new', component: ShopApplicationPage, meta: { title: '门店上报' } },
    { path: '/shops/:id/edit', component: ShopApplicationPage, meta: { title: '补充门店资料' } },
    { path: '/shops/:id', component: () => import('./pages/ShopReadonlyPage.vue'), meta: { title: '门店详情' } },
  ],
});
